import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpStatusCode } from '@angular/common/http';
import { ControlEvent } from '@models/control-event.model';
import { Observable } from 'rxjs';
import { api } from '@consts/url.const';
import { UtilsV2Service } from './utils-v2.service';

@Injectable({
  providedIn: 'root'
})
export class ControlEventsService {
  private httpClient = inject(HttpClient);
  private utilsV2Service = inject(UtilsV2Service);

  public getControlEvents(
    page: number,
    size: number,
    filters?: ControlEvent.QueryParamFilters
  ): Observable<ControlEvent.PaginationResult<ControlEvent.AccessControlEvent>> {

    const body: { [key: string]: any } = {
      page,
      size,
    };

    if (filters) {
      const { dateRange, ...otherFilters } = filters;

      const serverDateRange = this.utilsV2Service.dateRangeToServerRequest(dateRange);
      if (serverDateRange) {
        body['timestampStart'] = serverDateRange.start;
        body['timestampEnd'] = serverDateRange.end;
      }

      for (const [key, value] of Object.entries(otherFilters)) {
        const isValidArray = Array.isArray(value) && value.length > 0;
        const isValidValue = !Array.isArray(value) && value != null;

        if (isValidArray || isValidValue) {
          body[key] = value;
        }
      }
    }
    return this.httpClient.post<ControlEvent.PaginationResult<ControlEvent.AccessControlEvent>>(
      api.accessControlEvents.controlEvents,
      body
    );
  }

  public getDistinct(): Observable<ControlEvent.Distinct> {
    return this.httpClient.get<ControlEvent.Distinct>(api.accessControlEvents.distinct);
  }

  public getControlEventDetails(id: number): Observable<ControlEvent.AccessControlEventDetails> {
    return this.httpClient.get<ControlEvent.AccessControlEventDetails>(api.accessControlEvents.details(id));
  }

  public getControlEventMessages(eventId: number): Observable<ControlEvent.EventComment[]> {
    return this.httpClient.get<ControlEvent.EventComment[]>(api.accessControlEvents.comments.list(eventId));
  }

  public createControlEventComment(eventId: number, comment: ControlEvent.AddCommentRequest): Observable<HttpStatusCode> {
    return this.httpClient.post<HttpStatusCode>(api.accessControlEvents.comments.create(eventId), {...comment});
  }

  public updateControlEventComment(comment: ControlEvent.UpdateCommentRequest): Observable<HttpStatusCode> {
    return this.httpClient.put<HttpStatusCode>(api.accessControlEvents.comments.update(comment.commentId), { text: comment.text });
  }

  public deleteControlEventComment(commentId: number): Observable<HttpStatusCode> {
    return this.httpClient.delete<HttpStatusCode>(api.accessControlEvents.comments.delete(commentId));
  }
}
